import { Container } from './Sidebar.styles';

type SidebarProps = {
  children: React.ReactNode;
};

export const Sidebar = ({ children }: SidebarProps) => {
  return <Container>{children}</Container>;
};
